import { render, staticRenderFns } from "./RegisterPointOfInterest.vue?vue&type=template&id=53184284&"
import script from "./RegisterPointOfInterest.vue?vue&type=script&lang=js&"
export * from "./RegisterPointOfInterest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports